import { Advisor } from './../../../models/advisors';
import { Component, OnInit, Input, Inject, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Survey } from 'src/app/models/survey';
import { SurveyV2Service } from 'src/app/services/surveyV2.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-survey-profile',
    templateUrl: './survey-profile.component.html',
    styleUrls: ['./survey-profile.component.scss'],
    imports: [CommonModule,FormsModule,ReactiveFormsModule],
     changeDetection: ChangeDetectionStrategy.Default
})
export class SurveyProfileComponent implements OnInit {

  firstName = "";
  lastName = "";
  email = "";
  phone = "";
  state = "Select A State:";
  country = "United States";
  advisor = "111";
  isFirstNameValid = null;
  isLastNameValid = null;
  isEmailValid = null;
  isPhoneValid = null;
  isAdvisorValid = null;
  sending = false;
  surveyResultId
  surveyId

  surveyID:number = 0;
  survey:Survey|undefined;
  
  constructor(public hc: HttpClient, private route: ActivatedRoute, public router: Router, private surveyV2Service: SurveyV2Service, @Inject(PLATFORM_ID) private platformId: Object) {

    if (isPlatformBrowser(this.platformId)) {
      var surveyID = localStorage.getItem("surveyID");
          if(surveyID!=null){
             // console.log(`trying to load survey# ${surveyID} from localStroage:`);
              var survey = localStorage.getItem(surveyID+ "_survey");
              //console.log("SURVEY FOUND",survey);
              if(survey!=null){
          
                  this.survey = JSON.parse(survey);
                //  console.log("SURVEY FOUND",this.survey);
                }
          }     
    }

   }


  errorMessages = {
    firstName: 'Name must be at least 2 characters long.',
    lastName: 'Last name must be at least 2 characters long.',
    email: 'Email is invalid.',
    phone: 'Phone is invalid.',
    //advisor: 'Must select an advisor'

  }



  profileFirstName = "";
  profileLastName = "";
  profileEmail = "";
  profilePhone = "";
  profileState = "";
  profileCountry = "";
  profileAdvisor = "";
  profileMessage = "";
  firstNameValidationText = "";
  lastNameValidationText = "";
  emailValidationText = "";
  phoneValidationText = "";
  //advisorValidationText = "";

  

  validateFirstName() {
    this.isFirstNameValid = (this.firstName.length >= 2);
    if (this.isFirstNameValid) {
      this.firstNameValidationText =  "";
    } else {
      this.firstNameValidationText = (this.errorMessages.firstName);
    }
  }

  validateLastName() {
    this.isLastNameValid = (this.lastName.length >= 2);
    if (this.isLastNameValid) {
      this.lastNameValidationText =  "";
    } else {
      this.lastNameValidationText = (this.errorMessages.lastName);
    }
  }

  validateEmail() {
    var emailRegEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.isEmailValid = emailRegEx.test(this.email);
    if (this.isEmailValid) {
      this.emailValidationText = "";
    } else {
      this.emailValidationText = (this.errorMessages.email);
    }
  }

  validatePhone() {
    var phoneRegEx = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    this.isPhoneValid = phoneRegEx.test(this.phone);
    if (this.isPhoneValid) {
      this.phoneValidationText = "";
    } else {
      this.phoneValidationText = (this.errorMessages.phone)
    }
  }

  // validateAdvisor() {
  //   this.isAdvisorValid = (this.advisor.length >= 2);
  //   if (this.isAdvisorValid) {
  //     this.advisorValidationText =  "";
  //   } else {
  //     this.advisorValidationText = (this.errorMessages.advisor);
  //   }
  // }

  profileFormSubmit() {

// $&("formSubmitted") 

    this.validateEmail();
    this.validateFirstName();
    this.validateLastName();
    this.validatePhone();
    //this.validateAdvisor();

    if (this.isFirstNameValid && this.isLastNameValid && this.isEmailValid && this.isPhoneValid) {
      this.sending = true;

      var profileSubmission = {
         
         // "surveyResultId": this.surveyResultId,
         "guidSurveyResultID": this.survey?.guidSurveyResultID,
          "referrer": "Investing for Catholics",
          "ipAddress":"0",
          //"userId": localStorage.getItem("userId")?localStorage.getItem("userId"):0,
          "userId":0,
          "firstName": this.firstName,
          "lastName": this.lastName,
          "email": this.email,
          "phone": this.phone,
          "state": this.state,
          "country": this.country,
          "advisor": this.advisor,
          "subscribeToNewsletter": "false",
          "goalsList":""
        
      };

      this.sendProfile(profileSubmission);
     
    } else {
      error => {
        (error.message || "form submission error")
// $&(error)
      }
    }
  }

  sendProfile(data) {
    //var promise = this.hc.post("https://data2.ifa.com/api/v1/survey/user/", data)
    var promise = this.surveyV2Service.survey_profile_submit$(data)
    .subscribe((resp: any) => {

      //console.log("user resp",resp)
      localStorage.setItem("userId", resp.data[0].userID)

      if (resp.data[0].userID) {

        this.profileMessage = "Your profile was submitted successfully";
        this.router.navigate([`/survey/${this.surveyId}/result`])
        

      } else {

        this.profileMessage = "An error occured while submitting your profile, please try again.";

      }
    }, error => {
    
      this.profileMessage = "An error occured while submitting your profile, please try again.";

    })

  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.surveyResultId = localStorage.getItem(params.surveyId)
      this.surveyId = params.surveyId
    })
  }

}
